<template>
  <div>
		<div class="middle">
      <div class="middle-area">
        <p>同学们：</p>
        <br>
        <p v-html="arrDesc[id-1]"></p>
      </div>
		</div>
    <div class="bottom">
      <button class="back-button" @click="emitBackMission">返回</button>
      <button class="play-button" @click="nextStep">下一步</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios';
import qs from 'qs';
import setWechatTitle from '@/utils/setWechatTitle.js'
export default {
  name: 'intro',
  props: {
    id: Number
  },
  components: {
  },

  data () {
    return {
      arrDesc : [
        "你真的了解自己的性格吗？</br>你想要了解自己的性格吗？</br>现在，你就可以根据自己的真实想法回答下面的4道题，开启你的性格探索之旅！",
        "面临选择，我们究竟在考虑什么？其实考虑的就是价值观，也就是我们最看重的那个因素。</br>接下来的答题过程，就是你不断澄清价值观的过程，请根据自己的实际情况选择“是”或“否”。",
        "大学期间究竟要做些什么才能不虚此行？其实无外乎三件事：自我管理、教育&职业探索、决策&规划。</br>现在的你，做了哪些事呢？请认真阅读下面的表述，根据自己的实际情况作出选择。",
        "你了解自己的兴趣吗？你知道自己对哪些事情感兴趣吗？或许，接下来的测评能够让你进一步认识自己的兴趣。</br>以下题目均为排序题。都每一题有6条描述，请根据自己的真实情况，先选出“最吻合/喜欢”的项目，然后选出“第二吻合/喜欢”的项目，依次类推。具体来说，“1”为“最吻合/最喜欢”，“6”为“最不吻合/最不喜欢喜欢”。",
        "你知道吗，人和职业之间是存在匹配度的！匹配度越高，代表该职业越契合你的兴趣。</br>你想知道自己与期望从事职业之间的匹配度是多少吗？只需要从下列职业类别中选择自己想要从事的职业，就可以查看匹配度啦！",
        "很好奇匹配度是怎么来的？</br>这就是职业霍兰德代码的奥秘所在！当自己的兴趣代码和职业霍兰德代码越一致，匹配度就越高。</br>现在你可以尝试去探索自己感兴趣职业的霍兰德代码啦！ ",
        "一名优秀的大学生通常需要具备10种通用素质。作为大学生的你，在10种通用素质上的得分情况如何呢？</br>请阅读以下测评题目，根据自己的实际情况做出选择,就可以查看分数啦!",
        "不同的岗位需要从业人员具备不同的能力，那么你对岗位所要求的能力又了解多少呢？</br>现在你可以基于自己拥有的知识认真答题，不过答错一题闯关就结束啦，但是可以重复刷题破记录呦。",
        "要想知道自己能否胜任目标职位，前提是你得先了解目标职位有哪些能力要求！</br>现在你就可以按照操作步骤提示，查看自己了解到的目标职位能力与实际要求的能力是否一致呢!",
        "每个人在做决策的时候都会呈现出不同的特征，也就是不同的决策风格，那么你是何种决策风格呢，又有什么特征呢？请阅读下列表述，根据自己的实际情况做出选择，get自己的决策风格!",
        "求职时我们会搜集各种信息，但有一类信息往往容易被我们忽视，即国家对大学生就业的帮扶政策。关于毕业生就业的扶持政策，你究竟了解多少呢？</br>快去参与答题燃烧你的大脑吧！偷偷告诉你，想打败更多的答题者，可重复刷分呦！",
        "关于毕业后何去何从这个问题，我们如何才能做出一个理智的决策？</br>决策平衡单就是一个不错的工具。请根据操作步骤提示，借助决策平衡单，助力自己做出理智的毕业去向决策！",
        "在大学阶段，有一件非常重要的事情要做，就是确定自己的生涯目标，但是在这过程中会存在很多的困难导致我们迟迟不能决定。</br>所以接下来的测评，就是帮助你诊断问题、解决问题。请按照你的实际情况选择符合自己的分数，1-9表示非常不符合-非常符合。"
      ]
		}
  },

  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created(){
    setWechatTitle('活动导语');
  },
	beforeMount() {
	},
  mounted() {
  },
  updated() {
  },
  beforeDestroy () {
  },
  methods: {
    //返回闯关首页
    emitBackMission() {
      this.$emit('backMission')
    },
    //
    nextStep(){
      this.$emit('finish-intro')
    }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.middle
  margin:auto
  width: 7.02rem
  height: 12.48rem
  overflow-x: auto
  background: url(http://sys.rennengda.com/public/images/intro1.jpg) no-repeat 0 0
  // background-color :#FFFFFF
  // border:1px #BBBBBB solid;
  .middle-area
    margin: 3.4rem 0.6rem 0 0.9rem
    background-color :#FFFFFF
    padding: 0.02rem 0.12rem

.bottom
  padding: 0.24rem
  .back-button
    width: 42%
    height: 0.84rem
    margin-left: 0.4rem
    background: #787878
    border-radius: 0.12rem
    color: #fff
  .play-button
    width: 42%
    height: 0.84rem
    margin-left: 0.4rem
    background: #DC6E5A
    border-radius: 0.12rem
    color: #fff

</style>
